import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import AppView from '~common/components/app-view/index';
import {Button, Toolbar, FormControl, InputLabel, Grid} from '@mui/material';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import QueryList from '~common/components/query-fulfillment/query-list-fc';

import portalUserContext from '~common/lib/portal-user-context';
import URLManager from '~common/lib/url-manager';

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  toolbar: {
    justifyContent: 'flex-end'
  },
  container: {
    width: '100%',
    // display: 'flex',
    // flexWrap: 'wrap',
    // justifyContent: 'space-around',
    overflow: 'hidden'
  },
  formDefField: {
    width: '100%'
  },
  displayText: {
    marginTop: 16,
    fontSize: '1.05rem'
  },
  pin: {
    opacity: 0.2,
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  status: 'loading' | 'ready';
  error?: any;
};

class FormAdminQueryList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'ready',
    };
  }

 componentDidMount() {
    // console.log("Into TSX")
  }

  handleActionsForItemRow = (row: any) => {
    var actions = Array<any>()
  
    return actions
  }

  handleRowClick = (item) => {
    var criteria = URLManager.getQueryString(window.location.href)
    window.location.href = `/bulletins/admin/${item.id}?q=${URLManager.getQueryStringValue(criteria)}`
  }

  renderGroup = (props: any) => {
      const {classes}: {classes: ClassNameMap} = this.props;
      
      var val = '--'
      if (props.value && props.value.value && props.value.value.id) {
        val = props.value.label
      } 
      return ( 
        <Grid item xs={props.fieldDefinition.gridAttributes.xs} sm={props.fieldDefinition.gridAttributes.sm} md={props.fieldDefinition.gridAttributes.md} lg={props.fieldDefinition.gridAttributes.lg} xl={props.fieldDefinition.gridAttributes.xl}>
            <FormControl className={classes.formDefField}>
            <InputLabel shrink>{props.fieldDefinition.title}</InputLabel>
            <div className={classes.displayText}>
              {val}
            </div>
          </FormControl>
         </Grid>
      )
  }

  renderPinned = (props: any) => {
    const {classes}: {classes: ClassNameMap} = this.props;
    var selector: any = null;  
    if (props.value) {
      if (props.value > 0) {
        selector = (
          <i className={classes.pin + ' fa fa-thumbtack'} />
        );
      }
    } 
    
    return ( 
      <Grid item xs={props.fieldDefinition.gridAttributes.xs} sm={props.fieldDefinition.gridAttributes.sm} md={props.fieldDefinition.gridAttributes.md} lg={props.fieldDefinition.gridAttributes.lg} xl={props.fieldDefinition.gridAttributes.xl}>
          <FormControl className={classes.formDefField}>
          <InputLabel shrink>{props.fieldDefinition.title}</InputLabel>
          <div className={classes.displayText}>
            {selector}
          </div>
        </FormControl>
      </Grid>
    )
}

  
  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {status} = this.state;
    

    var criteriaSelector = {
      "app": "admin",
      "form": "bulletinCriteria"
    }

    criteriaSelector["userType"] = portalUserContext.userType
    if (criteriaSelector["userType"] == "Portal Admin") {
      criteriaSelector["userType"] = "Internal"
    }

    var criteria = URLManager.getQueryString(window.location.href)
    var addNewURL = `/bulletins/admin/new?q=${URLManager.getQueryStringValue(criteria)}`

    switch (status) {
      case 'loading':
        return (
            <div className={classes.container}>
              <LoadingView classes={
                {}
              } />
            </div>
        );
      default:
        return (
            <div className={classes.container}>
                <QueryList
                  criteriaFormSelector={criteriaSelector}
                  resultsFormSelector={
                    {
                      "app":"admin",
                      "form":"bulletinResults"
                    }
                  }
                  queryUrl="/api/portal-bulletins/query"
                  forceExecuteOnLoad={false}
                  autoQuery={true}
                  addNewUrl={addNewURL}
                  supressSectionStatusIcon
                  actionsForItemRow={this.handleActionsForItemRow}
                  onRowClick={this.handleRowClick}
                  alwaysExecuteOnSubmit={true}
                  customRenderers={{
                    "renderPinned": this.renderPinned,
                    "renderGroup": this.renderGroup,
                  }}
                  submitButtonText={"Search"}
                  noResultsText="No Results Found"
              />
            </div>
        );
    }
  }
}

export default withStyles(styles)(FormAdminQueryList);



